import { overrides } from './environment.development';
import { ENVIRONMENT_DEFAULTS, Environment } from './environment.model';

/**
 * Presidio customer theme environment (PRODUCTION-INTENT feature flags + DEMO mock paths).
 *
 * Mock mode: `apiMockPaths` + `src/assets/mock-data` (see docs/presidio-api-contracts.md).
 * Remove/empty `apiMockPaths` when wiring live ICM.
 */
export const environment: Environment = {
  ...ENVIRONMENT_DEFAULTS,

  icmChannel: 'inSPIRED-inTRONICS_Business-Site',
  // Placeholder path shape for MockInterceptor URL matching.
  // REPLACE with the customer ICM base URL when going live.
  icmBaseURL: 'https://icm-dsspr-int.icm.intershop.de',
  themeColor: '#0c1b30',
  icmApplication: '-',
  hybridApplication: 'smb-responsive',

  // CUSTOMIZATION: Presidio prototype — mock all ICM REST until real ICM is wired.
  // Remove / empty this array to use live ICM at icmBaseURL.
  apiMockPaths: ['.*'],

  features: [
    ...ENVIRONMENT_DEFAULTS.features.filter(
      // DotCMS needs its own host; leave off during ICM-mock prototyping.
      // GEO (PWA 12.1.0) needs PDP tab design — keep off until approved (dias-migration-12.1.0).
      f => f !== 'dotCms' && f !== 'dotCmsUve' && f !== 'geo'
    ),
    'businessCustomerRegistration',
    'costCenters',
    'maps',
    'punchout',
    'quickorder',
    'quoting',
    'orderTemplates',
    // wishlists: B2C — leave off for B2B Presidio demo (use order templates instead)
    // guestCheckout: disabled — Presidio storefront is login-required (standalone UX)
    // quickView: disabled — PLP cards link to PDP; hover Quick View added no task value
    // tracking: needs SSR GTM store — leave off for client-only mock demo (avoids NgRx warning).
    // External GA4/GTM validation: add 'tracking' + non-prod gtmToken and run with SSR —
    // see docs/analytics-measurement-plan.md (Validation status).
    /* ICSA Features */
    'customQuickorder',
    'saveForLater',
    'onePageCheckout',
    'multipleShippingCheckout',
    'salesRep',
    'bulkOrder',
    'productVariationList', // B2B master PDP: variation list + bulk order
    'extraConfiguration',
    'invoice', // CUSTOMIZATION: Presidio prototype — mocked via assets/mock-data/invoices
    'presidioPortal', // CUSTOMIZATION: contracts / devices / reports (mock ICM)
    'presidioSalesAdmin', // CUSTOMIZATION: sales-rep/CSR price lists, catalogs, work-item respond
    'presidioDiscovery', // CUSTOMIZATION: discovery user mgmt + address visibility (LOCAL_MOCK)
    'presidioOrders', // CUSTOMIZATION: Orders Now list exclusions/filters (MVP 4.1.x LOCAL_MOCK)
    'presidioInvoices', // CUSTOMIZATION: Invoices Now refine/pay/inquire (MVP 5.1.x LOCAL_MOCK)
    'presidioFavorites', // CUSTOMIZATION: My Favorites single list (heart toggle; not ICM wishlists)
    'presidioOmnisearch', // CUSTOMIZATION: header typeahead across products + orders/invoices/quotes (scope delta A14)
    'presidioWarehouse', // CUSTOMIZATION: My Warehouse held-stock PLP (MVP 2.6.3)
    // 'dotCms',      // enable with real DotCMS endpoint
    // 'dotCmsUve',
    // 'sparqueSearch',
  ],
  productListingItemsPerPage: {
    // CUSTOMIZATION: DIAS-aligned page size — endless scroll loads more of the ~30-product mock catalog
    category: 12,
    search: 12,
    master: 6,
  },
  // CUSTOMIZATION: default list view on PLP / SRP (B2B-dense comparison)
  defaultProductListingViewType: 'list',
  /* identityProvider: 'Punchout',
  identityProviders: {
    Punchout: {
      type: 'PUNCHOUT',
    },
  }, */
  // sparque: {
  //   serverUrl: 'https://api.search.sparque.ai',
  //   workspaceName: 'dss',
  //   apiName: 'PWA',
  //   config: 'default',
  //   channelId: 'ish',
  //   features: ['recommendations', 'search', 'suggestions'],
  // },
  ...overrides,
};
